export default __webpack_public_path__ + "images/8940d7f292cded646abcadf2aeb6f227-judaism.jpg";